import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface ConfettiCelebrationProps {
  trigger: boolean;
  message: string;
}
export function ConfettiCelebration({
  trigger,
  message
}: ConfettiCelebrationProps) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (trigger) {
      setShow(true);
      const timer = setTimeout(() => setShow(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [trigger]);
  if (!show) return null;
  return <AnimatePresence data-id="element-276">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 pointer-events-none z-50 flex items-center justify-center" data-id="element-277">
        {/* Confetti particles */}
        <div className="absolute inset-0 overflow-hidden" data-id="element-278">
          {[...Array(30)].map((_, i) => <motion.div key={i} className="absolute w-3 h-3 rounded-full" style={{
          background: ['#fbbf24', '#f59e0b', '#4f46e5', '#10b981', '#fb7185'][i % 5],
          left: `${Math.random() * 100}%`,
          top: '-10%'
        }} initial={{
          y: 0,
          opacity: 1,
          rotate: 0
        }} animate={{
          y: window.innerHeight + 100,
          opacity: 0,
          rotate: 360,
          x: [0, (Math.random() - 0.5) * 200],
          transition: {
            duration: 2 + Math.random() * 2,
            delay: Math.random() * 0.5,
            ease: 'easeOut'
          }
        }} data-id="element-279" />)}
        </div>

        {/* Message */}
        <motion.div initial={{
        scale: 0,
        rotate: -180
      }} animate={{
        scale: 1,
        rotate: 0
      }} exit={{
        scale: 0,
        rotate: 180
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 15
      }} className="bg-white rounded-2xl shadow-2xl p-8 max-w-md pointer-events-auto" data-id="element-280">
          <div className="text-center" data-id="element-281">
            <motion.div animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 10, -10, 0]
          }} transition={{
            duration: 0.5,
            repeat: 3
          }} className="text-6xl mb-4" data-id="element-282">
              🎉
            </motion.div>
            <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-283">
              {message}
            </h3>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}